import * as THREE from 'three';
import { ElementRef } from "@angular/core";

// // Création de la scène
// const scene = new THREE.Scene();
// scene.background = new THREE.Color(0xf7f8fA);
// scene.backgroundIntensity = 0;
//
// // Création du renderer
// const renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });

export function setRenderer(elt: ElementRef, renderer: THREE.WebGLRenderer): void {
	renderer.setPixelRatio(2*window.devicePixelRatio);

	// Récupérer les dimensions du conteneur
	const containerWidth = elt.nativeElement.clientWidth;
	const containerHeight = elt.nativeElement.clientHeight;

	// Configurer le renderer pour qu'il s'adapte exactement au conteneur
	renderer.setSize(containerWidth, containerHeight);

	// Définir les styles CSS pour s'assurer que le canvas s'adapte correctement
	renderer.domElement.style.display = 'block';
	renderer.domElement.style.width = '100%';
	renderer.domElement.style.height = '100%';

	// Ajouter le canvas au conteneur
	elt.nativeElement.appendChild(renderer.domElement);
}

// export { scene, renderer };
